import { Injector } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';

export function registerLocaleFactory(injector: Injector) {
  const service = injector.get(TranslateService);

  return () => service.use('en').pipe(take(1));
}
